import React, { useState } from 'react';
import styled from 'styled-components';

import { Notification } from '../components/Notification';

export const NewItemForm = ({ saveItem }) => {
  const [formValue, setFormValue] = useState('');
  const [errors, setErrors] = useState('');

  const handleSubmit = e => {
    e.preventDefault();

    if (!formValue) {
      setErrors('Must have an item');

      setTimeout(() => {
        setErrors('');
      }, 5000);

      return;
    } else {
      setErrors('');
    }

    saveItem(formValue);
    setFormValue('');
    setErrors('');
  };

  return (
    <Wrapper>
      {errors && <Notification>{errors}</Notification>}
      <Input
        type="text"
        onChange={e => setFormValue(e.target.value)}
        value={formValue}
      />
      <Button onClick={handleSubmit}>Add item</Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
`;

const Input = styled.input`
  padding: 10px;
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  border: 1px solid var(--theme-secondary-color);
  flex-basis: 70%;
  font-size: 16px;
`;

const Button = styled.button`
  background-color: var(--theme-secondary-color);
  color: var(--theme-primary-color);
  border: 1px solid var(--theme-primary-color);
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  padding: 10px;
  flex-basis: 30%;
`;
